import { useAuth } from "context/AuthProvider";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  UncontrolledAlert,
} from "reactstrap";
import { apiCentrosService } from "services/apiCentrosService";
import { apiDepartamentosService } from "services/apiDepartamentosService";
import { apiEmpleadosService } from "services/apiEmpleadosService";
import { apiHorariosService } from "services/apiHorariosService";

const AddEmpleado = (props) => {
  const { empresa } = useAuth();
  const navigate = useNavigate();
  const [nombre, setNombre] = useState(props.empleado?.nombre || "");
  const [apellidos, setApellidos] = useState(props.empleado?.apellidos || "");
  const [departamento, setDepartamento] = useState(
    props.empleado?.departamentoId || ""
  );
  const [centro, setCentro] = useState(props.empleado?.centroId || "");
  const [horario, setHorario] = useState(props.empleado?.horarioId || "");
  const [usuario, setUsuario] = useState(props.empleado?.usuario || "");

  const [fechaAlta, setFechaAlta] = useState(
    props.empleado?.fechaAlta || new Date().toISOString().split("T")[0]
  );
  const [fechaBaja, setFechaBaja] = useState(props.empleado?.fechaBaja || "");

  const [departamentos, setDepartamentos] = useState([]);
  const [centros, setCentros] = useState([]);
  const [horarios, setHorarios] = useState([]);

  const [status, setStatus] = useState("pending");
  const [teletrabajo, setTeletrabajo] = useState(props.empleado?.teletrabajo || false);

  
  const [diasVacaciones, setDiasVacaciones] = useState(props.empleado?.diasVacaciones || "");

  useEffect(() => {
    const fetchData = async () => {
      const dataDepartamentos = await apiDepartamentosService.getAll(
        empresa.id,
        0,
        1000
      );
      setDepartamentos(dataDepartamentos.content);
      const dataCentros = await apiCentrosService.getAllCentros(empresa.id);
      setCentros(dataCentros.content);
      const dataHorarios = await apiHorariosService.getAll(empresa.id, 0, 1000);
      setHorarios(dataHorarios.content);
    };
    fetchData();

    return () => {};
  }, [empresa.id]);

  
  const handleClear = (e) => {
    e.preventDefault();
    setNombre("");
    setApellidos("");
    setDepartamento("");
    setCentro("");
    setHorario("");
    setUsuario("");
    setFechaAlta(new Date().toISOString().split("T")[0]);
    setFechaBaja("");
    setTeletrabajo(false);
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    let response;
    let json = {
      "empresaId":empresa.id,
      "departamentoId":departamento,
      "centroId":centro,
      "horarioId":horario,
      "nombre":nombre,
      "apellidos":apellidos,
      "estado":"",
      "fechaAlta":fechaAlta,
      "fechaBaja":fechaBaja,
      "usuario":usuario,
      "diasVacaciones":diasVacaciones,
      "habilitado":true,
      "teletrabajo": teletrabajo
    };

  
  
    try{
      if (props.empleado?.id) {
        response = await apiEmpleadosService.updateEmpleado(
          props.empleado.id,
          json
        );
        setStatus(response.status);
      } else {


        response = await apiEmpleadosService.createEmpleado(json);
        setStatus("CREATED");
      
          handleClear(e);
        
      }
      console.log(json)
    }catch(error){
      if(error.error_code === "DUPLICATED_ENTITY"){
        setStatus("DUPLICATED_ENTITY")
      }else{
        setStatus("ERROR")
      }
      
    }

    // Limpiar el estado después de 3 segundos
    setTimeout(() => {
      setStatus("pending");
    }, 3000);
  };

  //espacio que ocupan los inpus en las columnas
  return (
    <>
      <Card>
        <CardHeader>
          <h3>{props.titulo}:</h3>
        </CardHeader>
        <CardBody>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col lg="6">
                <FormGroup>
                  <Label htmlFor="nombre" className="form-control-label">
                    Nombre:
                  </Label>
                  <Input
                    type="text"
                    name="nombre"
                    className="form-control-alternative"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    required
              
                  ></Input>
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label htmlFor="Apellidos" className="form-control-label">
                    Apellidos:
                  </Label>
                  <Input
                    type="text"
                    name="Apellidos"
                    className="form-control-alternative"
                    value={apellidos}
                    onChange={(e) => setApellidos(e.target.value)}
                    required
                  ></Input>
                </FormGroup>
              </Col>
              <Col lg="4">
                <FormGroup>
                  <Label htmlFor="Departamento" className="form-control-label">
                    Departamento:
                  </Label>
                  <Input
                    type="select"
                    name="Departamento"
                    className="form-control-alternative"
                    value={departamento}
                    onChange={(e) => setDepartamento(e.target.value)}
                    required
                  >
                    <option value={""}>Selecione un departamento</option>
                    {departamentos.map((dep) => {
                      return (
                        <option key={dep.id} value={dep.id}>
                          {dep.nombre}
                        </option>
                      );
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col lg="4">
                <FormGroup>
                  <Label htmlFor="Centro" className="form-control-label">
                    Centro:
                  </Label>
                  <Input
                    type="select"
                    name="Centro"
                    className="form-control-alternative"
                    value={centro}
                    onChange={(e) => setCentro(e.target.value)}
                    required
                  >
                    <option value={""}>Selecione un centro</option>
                    {centros.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.nombre}
                        </option>
                      );
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col lg="4">
                <FormGroup>
                  <Label htmlFor="horario" className="form-control-label">
                    Horario:
                  </Label>
                  <Input
                    type="select"
                    name="horario"
                    className="form-control-alternative"
                    value={horario}
                    onChange={(e) => setHorario(e.target.value)}
                    
                  >
                    <option value={""}>Selecione un horario</option>
                    {horarios.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.titulo}
                        </option>
                      );
                    })}
                    *
                  </Input>
                </FormGroup>
              </Col>
              
              <Col lg="12">
                <FormGroup>
                  <Label htmlFor="usuario" className="form-control-label">
                    Usuario:
                  </Label>
               
                  <Input
                    type="number"
                    name="usuario"
                    min={1}
                    max={999}
                    className="form-control-alternative"
                    value={usuario}
                    onChange={(e) => setUsuario(e.target.value)}
                    required

                    disabled={props.empleado?.id ? true : false}

                  ></Input>
                </FormGroup>
              </Col>
           
              <Col lg="6">
                <FormGroup>
                  <Label htmlFor="fecha_alta" className="form-control-label">
                    fecha de alta:
                  </Label>
                  <Input
                    type="date"
                    name="fecha_alta"
                    className="form-control-alternative"
                    value={fechaAlta}
                    onChange={(e) => setFechaAlta(e.target.value)}
                  ></Input>
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <Label htmlFor="fecha_alta" className="form-control-label">
                    fecha de baja:
                  </Label>
                  <Input
                    type="date"
                    name="fecha_alta"
                    className="form-control-alternative"
                    value={fechaBaja}
                    onChange={(e) => setFechaBaja(e.target.value)}
                  ></Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <Label
                    className="form-control-label"
                    htmlFor="diasVacaciones"
                  > 
                    Sobreescribir días de vacaciones anuales:
                  </Label>
                  <Input
                    className="form-control-alternative"
                    id="diasVacaciones"
                    type="number"
                    min={0}
                    max={365}
                    value={diasVacaciones}
                    onChange={(e) => setDiasVacaciones(e.target.value)}
                  />
                  
              </Col>
              {/*<Col>
                <div className="custom-control custom-checkbox mb-3">
                  <Input
                    className="form-control-alternative custom-control-input"
                    id="teletrabajo"
                    type="checkbox"
                  />
                  <Label
                    className=" form-control-label custom-control-label"
                    htmlFor="teletrabajo"
                  >
                    Teletrabajo
                  </Label>
                </div>
              </Col>-*/}
            </Row>
            <Row>
            <Col>
              <FormGroup check>
                  <Input
                      type='checkbox'
                      name='activo'
                      id='teletrabajo'
                      checked={teletrabajo}
                      onChange={(e) => setTeletrabajo(e.target.checked)}
                  />
                  <Label for="teletrabajo" className="form-control-label ml-2">teletrabajo</Label>  
              </FormGroup>
              </Col>
          </Row>

            <div className="text-right">
              <Button className="btn btn-success" type="submit">
                Guardar
              </Button>
              <Button
                className="btn btn-secondary"
                onClick={() => navigate("/admin/empleados")}
              >
                Volver
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
      <div className="mt-3">
        {status === "CREATED" ? (
          <UncontrolledAlert color="success" fade={true}>
            <span className="alert-inner--icon">
              <i className="ni ni-like-2" />
            </span>{" "}
            <span className="alert-inner--text">
              <strong>¡Guardado!</strong> Se ha guardado correctamente
            </span>
          </UncontrolledAlert>
        ) : (
          ""
        )}
        {status === "DUPLICATED_ENTITY" ? (
          <UncontrolledAlert color="warning" fade={true}>
            <span className="alert-inner--icon">
              <i className="ni ni-fat-remove" />
            </span>{" "}
            <span className="alert-inner--text">
              <strong>¡Duplicado!</strong> Este usuario ya existe.
            </span>
          </UncontrolledAlert>
        ) : (
          ""
        )}

        {status === "ERROR" ? (
          <UncontrolledAlert color="danger" fade={true}>
            <span className="alert-inner--icon">
              <i className="ni ni-fat-remove" />
            </span>{" "}
            <span className="alert-inner--text">
              <strong>¡Error!</strong> Se ha producido un error.
            </span>
          </UncontrolledAlert>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default AddEmpleado;

